import { useLocation } from 'react-router-dom'
import { ProductLayoutVariant, UseProductLayoutResult } from './types'

export const useProductLayout = (): UseProductLayoutResult => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const layoutParam = params.get('layout')

  const layout: ProductLayoutVariant = layoutParam === 'list' || layoutParam === 'grid' ? layoutParam : 'grid'

  return { layout }
}
